var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.70293,
    width: 28.6,
    height: 28.6,
    rx: 14.3,
    fill: "#E8F5FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5843 9.5241L10.5843 9.52413C9.1448 10.5722 8.19799 12.1205 7.92146 13.8797L7.92146 13.8797C7.52207 16.4206 8.61996 18.8556 10.5561 20.2864L10.3528 20.559C8.31716 19.0533 7.16653 16.4934 7.58573 13.827C7.87689 11.9761 8.86984 10.3521 10.3842 9.24938C11.688 8.30008 13.241 7.83917 14.8272 7.9142L16.1667 7.97755L15.1957 7.0527L14.3073 6.20652L14.4373 6.07012L15.9948 7.55399L15.995 7.55422L16.4919 8.02824L16.0172 8.5261L16.017 8.5263L14.5333 10.0839L14.3974 9.95423L15.2112 9.1005L15.9573 8.31777L14.8777 8.25633C13.3447 8.16908 11.8407 8.60949 10.5843 9.5241Z",
    stroke: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4156 20.4818L19.4157 20.4818C20.8551 19.4336 21.8019 17.8853 22.0784 16.1262L22.0784 16.1262C22.4778 13.5852 21.3799 11.1503 19.4437 9.71956L19.647 9.44686C21.6827 10.9526 22.8333 13.5125 22.4142 16.1789C22.123 18.0298 21.1301 19.6538 19.6157 20.7565C18.312 21.7058 16.759 22.1668 15.1727 22.0918L13.8333 22.0284L14.8043 22.9533L15.6927 23.7994L15.5627 23.9358L14.0052 22.452L14.0049 22.4518L13.508 21.9778L13.9828 21.4799L13.983 21.4797L15.4666 19.9221L15.6025 20.0517L14.7888 20.9055L14.0427 21.6882L15.1223 21.7496C16.6553 21.8369 18.1592 21.3964 19.4156 20.4818Z",
    stroke: "#4D4D4D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.70293,
    width: 28.6,
    height: 28.6,
    rx: 14.3,
    stroke: "#4D4D4D",
    strokeWidth: 1.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.6ba37f9b5654c9ba87c5eda27a09fac7.svg";
export { ForwardRef as ReactComponent };